import { defineStore } from 'pinia';
import {ref} from 'vue';

export const useGlobalStore = defineStore('global', () => {
  const isSidebarMinimized = ref(false);

  return {
    isSidebarMinimized
  }
});
